module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    class: _vm.classes,
    attrs: {
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "form__loading"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.success && _vm.successMessage) ? _c('div', {
    staticClass: "form__success",
    domProps: {
      "innerHTML": _vm._s(_vm.successMessage)
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _vm._t("default", null, {
    data: _vm.fields,
    errors: _vm.errors,
    file: _vm.file
  }) : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader"
  }, [_c('span'), _c('span'), _c('span')])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b840080","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Form.vue
// module id = 2smp
// module chunks = 1